<template>
<div class="pa-6 mx-auto">
  <v-container>
    <v-alert 
      v-if="displayAlert == true" 
      class="px-5 mx-auto"
      width="600" 
      :type="showAlert.type"
      :dismissible="!!showAlert.dismissable"
      dense
    >
      {{showAlert.message}}
    </v-alert>

    <v-card width="400" class="mx-auto">
      <v-card-title class="justify-center pa-2">
        <label class="title">{{ $t('forgetPassword.forgetPassword') }}</label>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form ref="forgetPasswordForm" v-model="formValidity" @submit.prevent="forgetPassword">
          <v-container class="pb-0">
            <v-text-field 
              :label="$t('forgetPassword.accountNumber')"
              v-model="leAccountNumber"
              :rules="leAccountNumberRules"
              prepend-icon="mdi-account-circle"
              required
              outlined
              dense
            />
            <v-text-field 
              :label="$t('forgetPassword.email')"
              type="email"
              v-model="email"
              :rules="emailRules"
              prepend-icon="mdi-email"
              required
              outlined
              dense
            />
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-btn 
          color="#D32F2F"
          @click="resetForm"
          class="ma-5"
          dark
        >{{ $t('clear') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          color="#173862"
          :disabled="!formValidity"
          @click="forgetPassword"
          class="ma-5"
          dark
        >{{ $t('forgetPassword.submit') }}</v-btn>
      </v-card-actions>
    </v-card>
    <p class="mx-auto mt-5">
      {{ $t('forgetPassword.goBack') }} <router-link to="/login">{{ $t('login.login') }} </router-link>
    </p>
  </v-container>
</div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { load } from 'recaptcha-v3'
  import i18n from '../i18n';

  load(process.env.VUE_APP_RECAPTCHA_SITE_KEY,{
    useRecaptchaNet: true,
    explicitRenderParameters:{
      badge: 'bottomleft',
      tabindex: 3
    }
  });

  export default {
    data: () => ({
      showAlert: {},
      displayAlert: false,
      email: '',
      emailRules: [
        value => !!value || i18n.t('validation.email.isRequired'),
        value => value.indexOf('@') !== 0 || i18n.t('validation.email.shouldHaveUsername'),
        value => value.includes('@') || i18n.t('validation.email.shouldIncludeAt'),
        value => value.lastIndexOf('.') - value.indexOf('@') > 1 || i18n.t('validation.email.missingPeriodSymbol'),
        value => value.lastIndexOf('.') <= value.length - 3 || i18n.t('validation.email.invalidExtension')
      ],
      error: null,
      formValidity: false,
      name: 'ForgetPasswordPage',
      leAccountNumber: '',
      leAccountNumberRules: [
        value => !!value || i18n.t('validation.accountNumber.isRequired'),
        // value => value.length == 0 || 'Account Number length must be 1 characters or more.'
      ]
    }),
    created () {
      this.$store.dispatch('users/resetState')
      this.$store.commit('users/SET_SNACK_IS_BLOCKED', false)
    },
    methods: {
      showSnack: function (snack, isError) {
        const setSnackObj = {
          message: snack,
          isError: !!isError
        }
        this.setSnack(setSnackObj)
      },
      ...mapMutations({
        // setSnack: 'snackbar/setSnack'
        setSnack: 'setSnack'
      }),
      resetForm() {
        this.$refs.forgetPasswordForm.reset()
      },
      async forgetPassword () {
        console.log(`[Forget Password]  - Request to reset user password!`)
        this.displayAlert = false;
        this.showAlert = {};
        
        this.$store
        .dispatch('users/forgetPassword', {
          username: this.email,
          accountId: this.leAccountNumber
        })
        .then((status) => {
          console.log(`[Foget Password]  - Valid user.`)

          if (status) {
            // Dispaly alert
            this.displayAlert = true;
            this.showAlert = { 
                type: 'success', 
                message: `${i18n.t('forgetPassword.requestSuccess')}`, 
                dismissable: true
            };

            this.resetForm();
            this.scrollToTop();
          }
        })
        .catch(err => {
          console.error(`[Foget Password] - Invalid user.`)

          // Dispaly alert
          this.displayAlert = true;
          this.showAlert = { 
            type: 'error', 
            message: (err.response.data.value.error.description) ? `${i18n.t('forgetPassword.requestFailure')} ${err.response.data.value.error.details}` : `${i18n.t('forgetPassword.requestFailure')} ${i18n.t('forgetPassword.tryAgain')}`,
            dismissable: true
          };
          
          this.scrollToTop();
        })
      },
      scrollToTop() {
        window.scrollTo(0,0);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>